import React, { useState } from 'react'
// import common from '../../methods/common'
import attendenceModals from '../../modals/attendenceModals'

const EditAttendence = () => {
    const [data, setData] = useState({})
    const buttons = ["Present", "Absent"]
    let { value } = data.date || ""

    const handleChange = (e) => {
        const { name, value } = e.target
        if (value) {
            setData(prev => ({ ...prev, [name]: value }))
        }
    }
    const edit = async (status) => {
        if(data.date){
            const response = await attendenceModals.editAttendence({ status, date:data.date })
            console.log(response)
        }
    }
    return (
        <div className='pm10'>
            <div className=''>
                <input type='date' name='date' value={value} onChange={handleChange} />
            </div>
            {buttons.map(item=>( <div className='pm2'>
                <button className='button-4 ' onClick={() => edit(item)} >{item}</button>
            </div>))}
        </div>
    )
}


export default EditAttendence
